"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Owner_1 = require("./_Owner");
exports._Object = {
    type: "structure",
    required: [],
    members: {
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        LastModified: {
            shape: {
                type: "timestamp"
            }
        },
        ETag: {
            shape: {
                type: "string"
            }
        },
        Size: {
            shape: {
                type: "integer"
            }
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        },
        Owner: {
            shape: _Owner_1._Owner
        }
    }
};
//# sourceMappingURL=_Object.js.map